import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../components/DynamicForm";
import {
  sponsorMasterUserFields,
  sponsorMasterUserValidationSchema,
} from "../../../Schema/SponsorMasterUserSchema";
import {
  useAddSponsorMasterUser,
  useGetAllSponsorsForAdmin,
} from "../../../custom-hooks/queries";
import NotificationModal from "../../../components/NotificationModal";

import { getApiErrorMessage } from "../../../utils/apiErrorMessage";
const AddSponsorMasterUser = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const { mutate: addUser, isError } = useAddSponsorMasterUser();

  // Existing sponsor orgs to attach the master to. Creating the org (with its HyperComply
  // org id + subscription) is a separate step (Add New Sponsor); the master must reference
  // one of those orgs rather than minting a brand-new, bare sponsor id.
  const { data: sponsors } = useGetAllSponsorsForAdmin({
    page_size: 1000,
    current_page: 1,
  });
  const sponsorItems = useMemo(() => sponsors?.items || [], [sponsors?.items]);

  // Inject the org options into the sponsor_id picker, with an empty first entry so the
  // required-field validation forces an explicit choice.
  const fields = useMemo(
    () =>
      sponsorMasterUserFields.map((field) =>
        field.name === "sponsor_id"
          ? {
              ...field,
              options: [
                { value: "", label: "Select organization" },
                ...sponsorItems.map((s) => ({
                  value: s.sponsor_id,
                  label: s.sponsor_name,
                })),
              ],
            }
          : field
      ),
    [sponsorItems]
  );

  const onSubmit = (data) => {
    const selected = sponsorItems.find((s) => s.sponsor_id === data.sponsor_id);
    const userData = {
      ...data,
      sponsor_id: data.sponsor_id,
      sponsor_name: selected?.sponsor_name ?? data.sponsor_name,
    };

    addUser(userData, {
      onSuccess: () => {
        setMessage("Sponsor Master User created successfully");
        setShow(true);
        setTimeout(() => navigate("/Backend/Users/SponsorMasterUsers"), 2000);
      },
      onError: (error) => {
        setMessage(getApiErrorMessage(error, "Failed to create user"));
        setShow(true);
      },
    });
  };

  return (
    <>
      <DynamicForm
        formTitle="Add New Sponsor Master User"
        formDescription="Complete the information below to create a new Sponsor Master User."
        fields={fields}
        validationSchema={sponsorMasterUserValidationSchema}
        onSubmit={onSubmit}
      />
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={isError ? "Error" : "Success"}
        error={isError}
      />
    </>
  );
};

export default AddSponsorMasterUser;
